import React from 'react';
import { View, Text } from 'react-native-web';
import Lottie from 'react-lottie';
import * as animationData from '../../lotties/lottie_orders_tab.json';

import GLOBAL from '../../configs/config_global';

export function Orders() {
    return(
        <View style={{ width: '100%', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: animationData,
                    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
                }}
                width={240}
                height={240}
                isStopped={false}
                isPaused={false}
            />

            <Text style={{ color: 'gray', fontSize: 20, fontWeight: 'bold', marginTop: 24 }}>
                Orders
            </Text>

            <Text style={{ color: 'gray', fontSize: 18, marginTop: 8 }}>
                Coming Soon
            </Text>

            <View style={{
                alignSelf: 'center', alignItems: 'center', margin: 32, marginTop: 64,
                borderWidth: 1, borderRadius: 8, borderColor: GLOBAL.COLOR.TEXT_LIGHT_GRAY,
                paddingHorizontal: 16, paddingVertical: 12
            }}>
                <Text style={{ color: 'gray', fontWeight: '500', fontSize: 18, lineHeight: 28, textAlign: 'center' }}>
                    Download the Truckster Vendor app on the Apple App Store or Google Play Store for access to this feature
                </Text>
            </View>
        </View>
    );
}
